import { Navbar } from '@stratumn/atomic';

import to from 'await-to-js';
import { ANALYTICS_URL, TRACE_URL } from 'constant/api';
import { env } from 'constant/env';
import { ROUTE_HOME, ROUTE_LOGIN } from 'constant/routes';
import compose from 'lodash.flowright';
import PropType from 'prop-types';
import { withRouter } from 'react-router-dom';
import { withRestClient } from 'wrappers/restClient';

export const Header = ({ history, user, client }) => {
  const signOut = async () => {
    const [err] = await to(client.logout());
    // generic error handling is done by the client
    if (err) return;
    history.push(ROUTE_LOGIN);
  };

  const currentPage = {
    name: 'Account',
    url: ROUTE_HOME
  };

  const links = [
    {
      name: 'Trace',
      url: TRACE_URL
    },
    {
      name: 'Analytics',
      url: ANALYTICS_URL
    }
  ];

  const menuLinks = [
    {
      link: currentPage,
      iconName: 'Profile'
    }
  ];

  return (
    <Navbar
      currentPage={currentPage}
      environmentName={env.VITE_ENVIRONMENT}
      links={links}
      menuLinks={menuLinks}
      signOut={() => signOut()}
      userAvatarPath={user?.avatar}
    />
  );
};

Header.propTypes = {
  history: PropType.object.isRequired,
  user: PropType.object.isRequired,
  client: PropType.object.isRequired
};

export default compose(withRouter, withRestClient)(Header);
